<p-table
  #dt1
  [value]="data"
  dataKey="id"
  [rows]="50"
  [showCurrentPageReport]="true"
  [rowsPerPageOptions]="[10, 25, 50]"
  styleClass="p-datatable-customers p-datatable-gridlines "
  [paginator]="false"
>
  <ng-template pTemplate="caption">
    <div [formGroup]="form" class="page-control flex align-items-start">
      <div class="grid w-100">
        <div
          class="col-12 flex justify-content-between mb-2 align-items-center"
        >
          <h2 class="text-black-alpha-90">Analiza - Škart</h2>

          <div class="flex">
            <button
              class="main-btn"
              [disabled]="!form.valid || data.length == 0"
              (click)="onExportPdf()"
              [ngClass]="{ disabled: !form.valid || data.length == 0 }"
            >
              Export PDF <i class="pi pi-file-pdf"></i>
            </button>
          </div>
        </div>

        <div class="col-4">
          <div class="mb-0 flex">
            <p-calendar
              dateFormat="dd.mm.yy"
              class="filter-calendar w-full"
              placeholder="Datum od"
              (onSelect)="onSearch()"
              [showIcon]="true"
              formControlName="date_from"
            ></p-calendar>
            <button
              class="clear-btn ml-2"
              (click)="clearFilters('date_from')"
              pTooltip="Obriši filter"
              tooltipPosition="top"
            >
              <i class="pi pi-times m-0"></i>
            </button>
          </div>
        </div>

        <div class="col-4">
          <div class="mb-0 flex">
            <p-calendar
              dateFormat="dd.mm.yy"
              class="filter-calendar w-full"
              placeholder="Datum do"
              (onSelect)="onSearch()"
              [showIcon]="true"
              formControlName="date_to"
            ></p-calendar>

            <button
              class="clear-btn ml-2"
              (click)="clearFilters('date_to')"
              pTooltip="Obriši filter"
              tooltipPosition="top"
            >
              <i class="pi pi-times m-0"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="header" let-item>
    <tr *ngIf="data.length != 0">
      <th style="padding: 0.5rem">
        <span>Razlog škarta</span>
      </th>

      <th
        *ngFor="let header of data[0]?.exists_operations"
        style="padding: 0.5rem"
      >
        {{ header.label }}
      </th>
      <th style="padding: 0.5rem">Ukupno škarta (kom)</th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-items>
    <tr *ngFor="let item of data[0].scrap_reasons">
      <td>Ljudski faktor</td>

      <td *ngFor="let header of data[0]?.exists_operations">
        <span>{{ item["human_factor"][header?.label] }}</span>
      </td>

      <td>
        <span>{{ item["human_factor"].total_scrap }}</span>
      </td>
    </tr>

    <tr *ngFor="let item of data[0].scrap_reasons">
      <td>Nejasna TD</td>

      <td *ngFor="let header of data[0]?.exists_operations">
        <span>{{ item["no_defined_td"][header?.label] }}</span>
      </td>

      <td>
        <span>{{ item["no_defined_td"].total_scrap }}</span>
      </td>
    </tr>

    <tr *ngFor="let item of data[0].scrap_reasons">
      <td>Ispravnost mašine</td>

      <td *ngFor="let header of data[0]?.exists_operations">
        <span>{{ item["machine_failure"][header?.label] }}</span>
      </td>

      <td>
        <span>{{ item["machine_failure"].total_scrap }}</span>
      </td>
    </tr>

    <tr *ngFor="let item of data[0].scrap_reasons">
      <td>Kvalitet materijala</td>

      <td *ngFor="let header of data[0]?.exists_operations">
        <span>{{ item["material_quality"][header?.label] }}</span>
      </td>

      <td>
        <span>{{ item["material_quality"].total_scrap }}</span>
      </td>
    </tr>

    <tr *ngFor="let item of data[0].scrap_reasons">
      <td>Ostalo</td>

      <td *ngFor="let header of data[0]?.exists_operations">
        <span>{{ item["other"][header?.label] }}</span>
      </td>

      <td>
        <span>{{ item["other"].total_scrap }}</span>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="10">Nema pronađenih prodataka.</td>
    </tr>
  </ng-template>
</p-table>

<div class="mt-4">
  <p-table
    #dt1
    [value]="data"
    dataKey="id"
    [rows]="10"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10, 25, 50]"
    styleClass="p-datatable-customers p-datatable-gridlines "
    [paginator]="false"
    class="mt-4"
    *ngIf="data.length != 0"
  >
    <ng-template pTemplate="header" let-item>
      <tr>
        <th style="padding: 0.5rem">
          <span></span>
        </th>

        <th
          *ngFor="let header of data[0]?.exists_operations"
          style="padding: 0.5rem"
        >
          {{ header.label }}
        </th>
        <th style="padding: 0.5rem">Ukupno škarta (kom)</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-item>
      <tr *ngFor="let item of data[0].summary">
        <td>
          <span> Ukupno škarta (kom)</span>
        </td>

        <td *ngFor="let header of data[0]?.exists_operations">
          <span>{{ item[header?.label] }}</span>
        </td>

        <td>
          <span>{{ item.total_scrap }}</span>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
